import { render, staticRenderFns } from "./UserEmailsSentList.vue?vue&type=template&id=5a10eb24&"
import script from "./UserEmailsSentList.vue?vue&type=script&lang=js&"
export * from "./UserEmailsSentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports